export enum PATHS {
  SUB_CATEGORIES = '/categories/',
  PRODUCTS = '/products/',
  CART = '/cart/',
  ORDER_DETAIL = '/order-detail/',
}